<template>
  <div class="">
    
    <PageHeader label="Uploading to Mercury Completed"></PageHeader>

    <div class="mt-8 text-base">
      Application has been successfully uploaded to Mercury.
    </div>

    <div class="mt-6">
      <router-link :to="{ name: 'client-list' }" 
        tag="a" 
        class="text-white uppercase bg-blue-500 font-semibold inline-block no-underline hover:bg-blue-600 text-xs p-2 mr-2">go to client list</router-link>
      <a href="https://m5.connective.com.au/mercury5/"
        target="_blank"
        class="text-white uppercase bg-green-500 font-semibold inline-block no-underline hover:bg-green-600 text-xs p-2">Go to Mercury</a>
    </div>

    <ShareBox />
  </div>
</template>

<script>
  import PageHeader from '@/shared/components/headers/PageHeader'
  import ShareBox   from '@/shared/components/ShareBox'

  export default {
    components : {
      PageHeader,
      ShareBox
    },
  }
</script>